export default ({ text }) => (
  <div className="flex items-center gap-4 rounded-md border border-primary-200 border-opacity-75 bg-primary-100 py-2 px-4 font-medium">
    <i className="far fa-info-circle text-xl text-primary-600"></i> {text}
  </div>
)
